import $ from "jquery";
import { cardResizedAdjustVisualization } from "./cards";
import toastr from "toastr";
import getParam from "./util/getParam";

let errorFlash;
let triggerPdf;

const sendSvgsForPdf = function () {
  $(".download-pdf-btn, .reset-pdf-btn").on("click", function (e) {
    e.preventDefault();

    const $card = $("#financial-data svg").closest("*[data-card]");
    const $cardBody = $card.find(".card-body");

    const chart = $card.find("[data-highcharts-chart]").highcharts();

    // TODO: Figure out why cardResizedAdjustVisualization doesn't handle text transform
    const lastPathD = $("#highcharts-0 > svg > g.highcharts-series-group > g.highcharts-series.highcharts-series-0.highcharts-tracker path:last-child").attr("d");

    const svgObjects = [];
    if (chart) {
      chart.legendShow();
      $cardBody.css("width", "880px");
      cardResizedAdjustVisualization(null, $card);

      // TODO: Figure out why cardResizedAdjustVisualization doesn't handle text transform
      if (lastPathD) {
        const unexpandedLeft = $("#highcharts-0 > svg > g.highcharts-series-group > g.highcharts-series.highcharts-series-0.highcharts-tracker path:last-child").attr("d").match(/L \d+\.\d+/)[0].replace(/L /, "");
        const unexpandedX = $("text[text-anchor=middle]").attr("x");
        const expandedLeft = $("#highcharts-0 > svg > g.highcharts-series-group > g.highcharts-series.highcharts-series-0.highcharts-tracker path:last-child").attr("d").match(/L \d+\.\d+/)[0].replace(/L /, "");
        const expandedDifference = expandedLeft - unexpandedLeft;
        $("text[text-anchor=middle]").css("transform", `translate(${expandedDifference}px)`);
        $("text[text-anchor=middle]").attr("x", parseFloat(unexpandedX) + expandedDifference);
        $("text[text-anchor=middle] tspan:last-child").attr("x", parseFloat(unexpandedX) + expandedDifference);
      }
    }

    const svgElements = document.querySelectorAll(".main-container svg");
    for (let i = 0; i < svgElements.length; i++) {
      const unfilteredSvg = $(svgElements[i]).parent().clone();
      const svg = unfilteredSvg.html();
      const svgName = $(svgElements[i]).closest(".card").data().chartTemplateType;
      const svgObj = { [svgName]: svg };

      if (svgName == "CompanyOwnershipStructure") {
        const legend = unfilteredSvg.find(".highcharts-legend");
        unfilteredSvg.find("[visibility=hidden]").remove();
        unfilteredSvg.find(".highcharts-button").remove();
        legend.children("g").last().remove();
        const transformVal = legend.attr("transform");
        legend.attr("transform", transformVal.replace(/,\d+/, ",10"));
      }

      svgObjects.push(svgObj);
    }

    if (chart) {
      $cardBody.css("width", "inherit");
      cardResizedAdjustVisualization(null, $card);
    }


    if (!triggerPdf) {
      toastr.success("Please wait whilst the PDF is generated. Do not navigate away from this page.", "", {
        "positionClass": "toast-top-center",
        "timeOut": 0
      });
    }

    $.post(this.href, {
      menu_item_slug: window.location.pathname.split("/")[window.location.pathname.split("/").length - 1],
      svgs: svgObjects
    }, function (data) {
      toastr.clear();
      toastr.success("PDF successfully generated", "", {
        "positionClass": "toast-top-center"
      });
      window.open(data);
    }).fail((data) => {
      toastr.error(`${data.statusText}<br />Our IT team has been notified and the error should be fixed within the next working day. If the problem persists, please contact support`, "", {
        "positionClass": "toast-top-center",
        "bodyOutputType": "trustedHtml",
        "timeOut": 8000
      });
    });
  });
};

const showErrorToastr = function () {
  if (errorFlash) {
    toastr.error(errorFlash, "", {
      "positionClass": "toast-top-center"
    });
  }
  if (triggerPdf) {
    $("a.download-pdf-btn").first().trigger("click");
  }
};

$(document).on("turbolinks:load", () => {
  $(".main-companies-table-container input.main-company-search").keyup(function () {
    const dt = $(".effective-datatable").DataTable();
    dt.column("name:name").search($(this).val()).draw();
  });
  errorFlash = getParam("error_flash");
  triggerPdf = getParam("trigger_pdf");
  $(document).ready(() => {
    sendSvgsForPdf();
    showErrorToastr();
  });
});
